import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import {VexPopoverService} from '@vex/components/vex-popover/vex-popover.service';
import {
  ToolbarNotificationsDropdownComponent
} from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatBadgeModule} from '@angular/material/badge';
import {FormsModule} from '@angular/forms';
import {AuthService} from '../../../../shared/services/auth.service';
import {GlobalService} from '../../../../shared/services/global.service';
import {PusherService} from '../../../../shared/services/pusher.service';
import {SocketService} from '../../../../shared/services/socket.service';
import {StorageService} from "../../../../shared/services/storage.service";
import Echo from "laravel-echo";
import Pusher from 'pusher-js';

@Component({
  selector: 'vex-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatBadgeModule, FormsModule],
  providers: [AuthService, GlobalService, SocketService],
})
export class ToolbarNotificationsComponent implements OnInit {
  @ViewChild('originRef', {static: true, read: ElementRef})
  originRef?: ElementRef;
  dropdownOpen: boolean = false;
  unreadNotification: number;
  user: any;
  private echo: Echo;
  window = {Pusher: null};


  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private cdr: ChangeDetectorRef,
    private pusherService: PusherService,
    private authService: AuthService,
  ) {
    const self = localStorage.getItem('self');
    if (self) {
      this.authService.self().subscribe(data => {
        if (data && data.id) {
          this.user = data;
        }
      });
    }
  }

  ngOnInit(): void {
    this.connectToSocket();
  }

  connectToSocket() {
    this.window.Pusher = Pusher;
    this.echo = new Echo({
      broadcaster: 'pusher',
      key: '93749af5fc1ecf9ab874',
      cluster: 'ap2',
      forceTLS: true
    });
    this.listenToChat();
  }

  listenToChat() {
    const self = StorageService.getItem('self');
    this.echo
      .channel(`chat_app_${self?.user_id}`)
      .listen('.message.sent', (data: any) => {
      });

  }

  showPopover(): void {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    if (!this.originRef) {
      throw new Error('originRef undefined!');
    }

    const popoverRef = this.popover.open({
      content: ToolbarNotificationsDropdownComponent,
      origin: this.originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
